export default {
  // Gallery page hero
  "gallery.hero.breadcrumb_home": "Home",
  "gallery.hero.breadcrumb_gallery": "Gallery",
  "gallery.hero.title": "Gallery FOPMN",
  "gallery.hero.subtitle": "Videos and authentic images from the daily activity of professional fishermen on the Black Sea.",
  "gallery.prev": "Previous",
  "gallery.next": "Next",
  "gallery.of": "of",

  // Media Showcase (video + photo gallery — on /galerie page)
  "home.media.label": "From the Field",
  "home.media.title": "FOPMN Fishermen in Action",
  "home.media.description": "Together with the entire Black Sea fishing community, our federation members actively contribute to maintaining and developing Romanian commercial fishing. Watch images and video footage from their daily work: from responsible management of fishing gear to unloading catches at authorized landing points and marketing.",
  "home.media.hint": "Click on image/video to view them enlarged.",
  "home.media.prev": "Previous video",
  "home.media.next": "Next video",
  "home.media.close": "Close",
  "home.media.video1": "Anchovy caught by pelagic trawl in the Black Sea",
  "home.media.video2": "Fish caught by pelagic trawl",
  "home.media.video3": "Launching pelagic trawl in the Black Sea",
  "home.media.video4": "Rapa whelk catch with Beam Trawl",
  "home.media.video5": "Beam Trawl launch at sea",
  "home.media.video6": "Record rapa whelk catch with divers",
  "home.media.video7": "Rapa whelk caught with divers",
  "home.media.video8": "Black Sea mussel catch",
  "home.media.video9": "Sorting and storing mussels on vessel",
  "home.media.video10": "Desanding and preparing fresh mussels for sale",
  "home.media.img1": "Record fish catch by pelagic trawl",
  "home.media.img2": "Fresh fish on board the vessel",
  "home.media.img3": "Rapa whelk catch with divers",
  "home.media.img4": "Trawlers heading out to sea",
  "home.media.img5": "Mixed catch: bluefish, horse mackerel, red mullet",
  "home.media.img6": "Fish caught by pelagic trawl",
  "home.media.img7": "Trawler docked at Black Sea port",
  "home.media.img8": "Trawler docked at port — side view",
  "home.media.img9": "Fish caught by pelagic trawl",
  "home.media.img10": "Mussel selection on vessel",
  "home.media.img11": "Fish selection at the First Sale Center",
  "home.media.img12": "Rapa whelk harvesting with divers",
  "home.media.img13": "Black Sea mussels — washing and desanding",
  "home.media.img14": "Freshly landed and desanded mussels",
  "home.media.img15": "Mussels prepared for sale",
  "home.media.img16": "Pelagic trawl in the Black Sea operated by FOPMN members",
  "home.media.img17": "Black Sea anchovy — at the trawl of FOPMN members",
  "home.media.img18": "Sewing the fishing net (purse)",
  "home.media.img19": "Vessels from the FOPMN fleet",
  "home.media.img20": "Fish processing and freezing factory",
  "home.media.img21": "Anchovy caught by pelagic trawl in the Black Sea",
};